import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ExperienceSection() {
  const benefits = ['Más paz interior.', 'Más claridad mental.', 'Más gratitud.', 'Más confianza en Dios.', 'Más disciplina espiritual.', 'Menos ansiedad.', 'Menos preocupación.', 'Una conexión más profunda y constante con Dios.'];
  return <section className="w-full bg-[#F7F2E7] py-20 px-6" data-id="element-69" data-mp="1b00jj4obzuw9">
      <div className="max-w-3xl mx-auto" data-id="element-70" data-mp="1b2d8i1sib5it">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-bold text-center text-[#0A1535] mb-12" data-id="element-71" data-mp="1f23wjxqnf7jn">
          Lo que experimentarás durante los próximos 30 días
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-72" data-mp="2fa22u824e3y5">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-3" data-id="element-73" data-mp="2b8zzpg5317qw" data-mpi={index}>
              <CheckCircle2 className="w-6 h-6 text-[#C9A24B] flex-shrink-0 mt-1" data-id="element-74" data-mp="37z0lr7e2ha4i" />
              <span className="text-lg text-[#0A1535]" data-id="element-75" data-mp="37wwi8qk2yd4r">{benefit}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}